/**
 * parent
 */
export default {
    name: 'parent',
    path: '/parent',
    meta: {},
    component: () => import('@/views/parent/Home'),
    redirect: '/parent/index',
    children: [
        {
            name: 'HomeworkNotice',
            path: 'homework/notice',
            meta: {},
            component: () => import('@/views/parent/homework/Notice'),
        },
    ],
};
